import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signOut } from "firebase/auth";
import { addDoc, collection, updateDoc, doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { IPersonaDBType } from "../utils/types";
// TODO: create Error handling

export class FirebaseService {

    static async logInWithEmailAndPassword(email: string, password: string) {
        try {
            return await signInWithEmailAndPassword(auth, email, password);
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };
      
    static async registerWithEmailAndPassword(username: string, email: string, password: string) {
        try {
            const res = await createUserWithEmailAndPassword(auth, email, password);
            const uid = res.user.uid;

            await setDoc(doc(db, "users", uid), {
                uid,
                username,
                authProvider: "local",
                email,
            });
            return res;
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };
      
    static async sendPasswordReset(email: string) {
        try {
            await sendPasswordResetEmail(auth, email);
            alert("Password reset link sent!");
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };

    static async logout() {
        await signOut(auth);
    };

    static async saveUserPersona(data: IPersonaDBType) {
        try {
            const uid = auth.currentUser?.uid || "";
            const userRef = doc(db, "users", uid);
            const userSnap = await getDoc(userRef);
            const userData = userSnap.data();
            const personaId = userData?.personaId;

            if (personaId) {
                const personaRef = doc(db, "personas", personaId);
                return await updateDoc(personaRef, {
                    ...data,
                    uid
                });
            } else {
                const personasData = await addDoc(collection(db, "personas"), {
                    ...data,
                    uid,
                });
                return await updateDoc(userRef, {
                    personaId: personasData.id
                });
            }
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };
}